






























































































































































































































import Vue from "vue"
import { DpdProduct } from "@/model/new-parcel-model/dpd-product/dpd-product"
import { CreateParcelModel } from "@/model/new-parcel-model/create-parcel-model"
import { plainToClass } from "class-transformer"
import { DpdProductVariant } from "@/model/new-parcel-model/dpd-product/dpd-product-variant"
import _ from "lodash"

interface Form {
  note: string
  reference: string
  reference2: string
  dimension: string
}

export interface IProductGroup extends Vue {
  parcelNumber: number
  sameWeight: boolean
  sameDimension: boolean
  dimensionsValid: boolean[]
  packageWeight: number
  labelWidth: string
  unitLabel: string
  validateMinPackageWeight: boolean
  packageWeightArray: number[]
  packageDimension: string
  packageDimensionArray: string[]
  form: Form
  resetAllFields: number

  clearAll(): void
}

export default Vue.extend({
  data() {
    return {
      sameWeight: false,
      sameDimension: false,
      packageDimension: "",
      packageDimensionArray: [],
      packageWeight: 0,
      labelWidth: "",
      unitLabel: "",
      validateMinPackageWeight: false,
      packageWeightArray: [0],
      dimensionsValid: [],
      form: {
        note: "",
        reference: "",
        reference2: "",
        dimension: ""
      },
      resetAllFields: 0,
      rules: {
        reference: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: any, callback: any) => {
              const isReferenceMandatory = this.createParcelModel.createParcelModelOptions.returnOfDocument.value
              if (isReferenceMandatory) {
                if (value === "") {
                  callback(new Error(`${this.$t("new_parcel.error.reference_mandatory")}`))
                }
              }
              callback()
            }
          }
        ],
        reference2: [
          {
            max: 50,
            message: `${this.$t("user_administration.max")} 50 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        note: [
          {
            max: 70,
            message: `${this.$t("user_administration.max")} 70 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        dimension: [
          {
            validator: (rule: any, value: any, callback: any) => {
              const vm = this as any
              const regex = /^\d{9}$/
              if (vm.packageDimension && !regex.test(vm.packageDimension)) {
                callback(new Error(`${this.$t("new.parcel.error.dimension.nine_numerical_characters")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          },
          {
            validator: (rule: any, value: string, callback: (err?: Error) => void) => {
              const vm = this as any
              if (vm.dimensionOptsPresent() && !vm.packageDimension) {
                callback(new Error(`${this.$t("user_administration.field_is_required")}`))
              }
              callback()
            },
            trigger: ["change", "blur"]
          }
        ]
      }
    }
  },
  props: {
    createParcelModel: {
      type: CreateParcelModel,
      required: true
    },
    country: {
      type: Object,
      required: true
    },
    dpdProducts: {
      type: Array as () => DpdProduct[],
      required: true
    },
    parcelNumber: {
      type: Number,
      required: true
    },
    productValidated: {
      type: Boolean,
      required: true
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    parcelPcs: {
      type: String
    },
    parcelWeight: {
      type: String
    },
    shipFromShop: {
      type: Boolean
    }
  },
  methods: {
    clearAll() {
      this.resetForm()
      this.sameWeight = false
      this.sameDimension = false
      this.packageWeight = 0
      this.packageWeightArray = [0]
      this.packageDimension = ""
      this.packageDimensionArray = []
      this.dimensionsValid = []
      this.form.note = ""
      this.form.reference = ""
      this.form.reference2 = ""
      this.$nextTick(() => this.emitValidation())
    },
    async changeProduct(dpdProduct: DpdProduct) {
      const vm = this
      await this.$http.get(`/product/employee_product_variant/${dpdProduct.type}/${this.country.id}`).then(res => {
        vm.createParcelModel.dpdProductVariants = plainToClass(DpdProductVariant, res.data)
        vm.createParcelModel.dpdProduct = dpdProduct
        vm.createParcelModel.consolidateVariantFromContext()
      })
      this.$nextTick(() => this.emitValidation())
    },
    emitValidation() {
      const vm = this as any
      vm.$refs.form.validate(valid => {
        this.$emit("update:productValidated", valid)
      })
    },
    // re-renders the form by increasing the key in the form by 1
    resetForm() {
      this.resetAllFields++
      this.$nextTick(() => this.$emit("update:receiverValidated", false))
    },
    dimensionOptsPresent(): boolean {
      return (
        !!this.createParcelModel.dpdProductVariant &&
        this.createParcelModel.dpdProductVariant.productType.toUpperCase() === "DPD_FREIGHT"
      )
    },
    dimensionArrIsEmpty(dimension: string): boolean {
      if (this.dimensionOptsPresent()) {
        if (!dimension) {
          return true
        }
        return false
      }
    },
    dimensionArrFormatIsValid(dimension: string): boolean {
      const regex = /^\d{9}$/
      if (dimension && !regex.test(dimension)) {
        return true
      }
      return false
    }
  },
  computed: {
    isExchangeParcel(): boolean {
      return this.createParcelModel.createParcelModelExtensions.exchange.value
    },
    isShopProduct(): boolean {
      if (
        ["DPD_SHOP", "DPD_SHOP_2_HOME", "DPD_SHOP_2_BUSINESS", "DPD_SHOP_2_SHOP"].includes(
          this.createParcelModel.dpdProduct.type
        )
      ) {
        this.packageWeightArray = [0]
        this.packageDimensionArray = []
        this.$emit("update:parcelNumber", 1)
        return true
      }
      return false
    },
    setWeightLabel(): string {
      if (this.createParcelModel.dpdProduct.type === "DPD_LIMITED_QUANTITY_BUSINESS" ||
        this.createParcelModel.dpdProduct.type === "DPD_LIMITED_QUANTITY_HOME") {
        this.unitLabel = "kg/l"
        this.labelWidth = "210px"
        return (this.$t("new_parcel.weight_and_volume") as string).capitalizeFirstChar().toString()
      } else {
        this.unitLabel = "kg"
        this.labelWidth = "170px"
        return (this.$t("new_parcel.weight") as string).capitalizeFirstChar()
      }
    }
  },
  watch: {
    isExchangeParcel: {
      handler(isExchange: boolean) {
        if (isExchange && this.parcelNumber !== 1) {
          this.$emit("update:parcelNumber", 1)
        }
      }
    },
    "form.reference": {
      handler() {
        this.emitValidation()
      }
    },
    "form.reference2": {
      handler() {
        this.emitValidation()
      }
    },
    "createParcelModel.createParcelModelOptions.returnOfDocument.value": {
      handler() {
        this.emitValidation()
      }
    },
    "form.note": {
      handler() {
        this.emitValidation()
      }
    },
    "form.dimension": {
      handler() {
        this.emitValidation()
      }
    },
    parcelNumber: {
      handler(newVal: number) {
        this.packageWeightArray = this.packageWeightArray.splice(newVal)
        this.packageDimensionArray = this.packageDimensionArray.splice(newVal)
        for (let index = 0; index < this.parcelNumber; index++) {
          if (!exists(this.packageWeightArray[index])) {
            this.packageWeightArray[index] = 0
          }
          if (!exists(this.packageDimensionArray[index])) {
            this.packageDimensionArray[index] = ""
          }
        }
      }
    },
    packageWeightArray: {
      deep: true,
      handler() {
        this.createParcelModel.weight = Math.min.apply(Math, this.packageWeightArray) * 1000
      }
    },
    packageWeight: {
      handler() {
        this.createParcelModel.weight = this.packageWeight
      }
    },
    packageDimensionArray: {
      deep: true,
      handler() {
        this.createParcelModel.dimension = (Math.min.apply(Math, this.packageDimensionArray) * 1000).toString()
      }
    },
    sameWeight: {
      handler() {
        if (this.sameWeight) {
          this.createParcelModel.weight = this.packageWeight
        } else {
          this.createParcelModel.weight = Math.min.apply(Math, this.packageWeightArray) * 1000
        }
      }
    },
    sameDimension: {
      handler() {
        if (this.sameDimension) {
          this.createParcelModel.dimension = this.packageDimension
        } else {
          this.createParcelModel.dimension = (Math.min.apply(Math, this.packageDimensionArray) * 1000).toString()
        }
      }
    }
  },
  mounted() {
    this.emitValidation()
  }
})
